const StationType = {
  COCO: "COCO",
  CODO: "CODO",
  CODOX: "CODOX",
  COXO: "COXO",
  WIBCO: "WIBCO",
  WILCO: "WILCO",
  WIDOX: "WIDOX",
  DODOX: "DODOX",
  DODO: "DODO",
};

export default StationType;
